import { useEffect, useState } from "react";

import { getLatestFacebookPosts } from "../api/facebook.api";

export const useLatestFacebookPosts = ({
  enabled = true,
} = {}) => {
  const [posts, setPosts] = useState([]);
  const [isLoading, setIsLoading] = useState(enabled);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!enabled) {
      setPosts([]);
      setIsLoading(false);

      return undefined;
    }

    const controller = new AbortController();

    const loadPosts = async () => {
      try {
        setIsLoading(true);
        setError(null);

        const result = await getLatestFacebookPosts({
          signal: controller.signal,
        });

        setPosts(
          Array.isArray(result) ? result : []
        );
      } catch (requestError) {
        if (requestError.name !== "AbortError") {
          setError(requestError);
          setPosts([]);
        }
      } finally {
        if (!controller.signal.aborted) {
          setIsLoading(false);
        }
      }
    };

    loadPosts();

    return () => controller.abort();
  }, [enabled]);

  return {
    posts,
    isLoading,
    error,
  };
};